const sanitizeLink = (link) => (link.endsWith('/') ? link : link + '/')

export const ROOT = '/'
// External link (login-settings, a different bundle) — not a login router
// route. Landing page for a user who ends up on the enforced-setup entry
// point without actually needing it (already compliant, or MFA no longer
// enforced).
export const SETTINGS_PAGE = '/users/settings'
export const INVALID_CREDENTIALS_HELP = ({ links: { support } }) =>
  `${sanitizeLink(support)}hc/en-us/articles/115005872146`
export const RECOVER_PASSWORD = '/users/password/recover'
export const AUTHENTICATE = '/authenticate'
export const OAUTH_AUTHORIZE = '/oauth/authorize'
export const LEARN_MORE_ABOUT_SECURITY_KEYS = ({ links: { support } }) =>
  `${sanitizeLink(support)}hc/en-us/articles/360020338552`
